import { useEffect, useState } from 'react';
import {GradientColor, GradientType} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator/types';
import {GradientBar} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator/GradientBar';
import {AnglePicker} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator/AnglePicker';
import {ColorPicker} from '@shortsworks/ui/components/ColorGenerator/ColorPicker';
import {Separator} from '@shortsworks/ui/index';

interface GradientGeneratorProps {
  gradientColor: GradientColor;
  onColorChange: (gradientColor: GradientColor) => void;
}

const defaultColor = (startColor: string = '#000000') => GradientColor.new(
  GradientType.Linear,
  [
    {color: startColor, offset: 0},
    {color: '#FFFFFF', offset: 1},
  ],
  90,
);

// grdientColor에 따라 픽커 색상 변경되도록 관리
export function GradientGenerator({ gradientColor = defaultColor(), onColorChange}: GradientGeneratorProps) {
  const [ selectedColorStopIndex, setSelectedColorStopIndex ] = useState<number>(0);
  const [ selectedColorStopColor, setSelectedColorStopColor ] = useState<string>(gradientColor.colorStops[0]!.color);

  useEffect(() => {
    setSelectedColorStopColor(gradientColor.colorStops[0]!.color);
  }, []);


  const handleColorChange = (gradientColor: GradientColor) => {
    onColorChange(gradientColor);
  }

  const handleSelectColorStop = (index: number) => {
    setSelectedColorStopIndex(index);
    setSelectedColorStopColor(gradientColor!.colorStops[index]!.color);
  }

  const handleColorStopColorChange = (color: string) => {
    const clone = gradientColor!.clone();
    clone.colorStops[selectedColorStopIndex]!.color = color;
    // setSelectedColorStopColor(color);
    onColorChange(clone);
  }

  const handleAngleChange = (angle: number) => {
    const clone = gradientColor!.cloneWithAngle(angle);
    onColorChange(clone);
  }

  return (
    <div className="w-full px-[18px] pt-[50px]">
      <div className="flex flex-col gap-4">
        <div className="w-full">
          <GradientBar
            selectedColorStopIndex={selectedColorStopIndex}
            gradientColor={gradientColor}
            onColorChange={handleColorChange}
            onSelectColorStop={handleSelectColorStop}
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-[13px]">각도</span>
          <AnglePicker angle={gradientColor.angle} onChange={handleAngleChange}/>
        </div>
        <Separator />
        <div className="w-full">
          {selectedColorStopColor && <ColorPicker showTitle={false} className="p-[0px]" color={selectedColorStopColor}
                                                  onColorChange={handleColorStopColorChange}/>}
        </div>
      </div>
    </div>
  )
}
